"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const index_1 = require("../index");
const react_1 = __importDefault(require("react"));
const CheckboxGroup = ({ options, selected, onChange, checkboxProps, columns = 1, columnWidth = '200px' }) => {
    const columnStyle = {
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, ${columnWidth})`,
    };
    return (react_1.default.createElement(index_1.FormGroup, { style: columns > 1 ? columnStyle : undefined, onChange: ({ target: { checked, value } }) => onChange(checked
            ? (0, lodash_1.concat)(selected, value)
            : (0, lodash_1.filter)(selected, (v) => v !== value)) }, options.map(({ label, value }) => (react_1.default.createElement(index_1.FormControlLabel, { key: value, control: react_1.default.createElement(index_1.Checkbox, { value: value.toString(), checked: selected.includes(value.toString()), color: "primary", ...checkboxProps }), label: label })))));
};
exports.default = CheckboxGroup;
